module.exports = __webpack_public_path__ + "static/media/1014984.ed18a289.jpg";